import { IStore } from 'store/types';

export const selectEmployeePayrollTips = () => (state: IStore) => state?.collections?.employeePayrollTips;
export const selectEmployeePayrollTipsTotal = () => (state: IStore) => state?.collections?.employeePayrollTips?.total || null;
